export default {
  data() {
    return {
      visited: []
    }
  },
  methods: {
    visit(data) {
      let id = data[this.key];
      if (this.visited.indexOf(id) === -1) {
        this.visited.push(id);
      }
    },
    getVisitedRowClassName({row}) {
      let rowClassName = '';
      if (this.visited.indexOf(row[this.key]) !== -1) {
        rowClassName += ' visited';
      }
      return rowClassName;
    }
  }
}